import { wrapNextPage } from '#/utils/next-wrappers/NextPage'
import Page from './page'

export default wrapNextPage(Page)
